import { ActionIcon, Group, Stack, Text, Title } from "@mantine/core";
import { IconArrowLeft } from "@/lib/icons";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export function PageHeader({
  title,
  subtitle,
  back,
  actions,
}: {
  title: string;
  subtitle?: string;
  back?: boolean | (() => void);
  actions?: ReactNode;
}) {
  const navigate = useNavigate();
  const onBack = typeof back === "function" ? back : () => navigate(-1);
  return (
    <Group justify="space-between" align="flex-start" mb="lg">
      <Group gap="md" align="center">
        {back && (
          <ActionIcon
            variant="subtle"
            color="gray"
            size="lg"
            radius="xl"
            onClick={onBack}
            aria-label="Back"
          >
            <IconArrowLeft size={20} strokeWidth={1.8} />
          </ActionIcon>
        )}
        <Stack gap={2}>
          <Title order={2} fw={700}>
            {title}
          </Title>
          {subtitle && (
            <Text c="dimmed" size="sm">
              {subtitle}
            </Text>
          )}
        </Stack>
      </Group>
      {actions && <Group gap="sm">{actions}</Group>}
    </Group>
  );
}

export function SectionCard({
  title,
  icon,
  children,
}: {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Stack gap="md">
      <Group gap="sm" align="center">
        {icon}
        <Title order={4} fw={700}>
          {title}
        </Title>
      </Group>
      {children}
    </Stack>
  );
}
